import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Spin } from 'antd';
import TemplateCreateEdit from './CreateEdit';
import {
  ICrmTemplate,
  getCrmTemplateById,
} from '../../../http/crm';

const TemplatesEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [template, setTemplate] = useState<ICrmTemplate | null>(null);
  const [, setTemplatesList] = useState<ICrmTemplate[]>([]);
  const [loading, setLoading] = useState(Boolean(id && id !== 'new'));

  const close = useCallback(() => navigate('/crm/templates'), [navigate]);

  useEffect(() => {
    let cancelled = false;
    if (id === 'new' || !id) {
      setTemplate(null);
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const data = await getCrmTemplateById(id);
        if (!cancelled) setTemplate(data);
      } catch (error: any) {
        if (!cancelled) {
          addToast({
            type: 'error',
            title: 'Erro',
            description:
              error?.response?.data?.error ??
              'Não foi possível carregar o template.',
          });
          close();
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, addToast, close]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <TemplateCreateEdit
      open
      close={close}
      template={template}
      setTemplates={setTemplatesList}
      onSaved={close}
    />
  );
};

export default TemplatesEdit;
